export const handleDateTime = (date: Date): string => {
  return new Date(date).toLocaleString("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatApiDateTime = (
  isoString: string | null | undefined,
): string => {
  if (!isoString) return "—";
  try {
    return handleDateTime(new Date(isoString));
  } catch {
    return isoString;
  }
};
